
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11500',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11500",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.214",
  "data-fetching-client": "static-1.9458",
  "foundations-components": "static-1.7485",
  "foundations-components-legacy": "static-1.510",
  "foundations-theming": "static-1.4189",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7785",
  "hub-http-shared-msw-handlers": "static-1.9431",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11203",
  "I18n": "static-7.1563",
  "jasmine-runner": "static-1.6251",
  "marketplace-storefront-base": "static-1.11560",
  "quartz": "static-1.6699",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16422",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2642",
  "reporting-testing-lib": "static-1.8372",
  "settings-ui-lib": "static-1.12300",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6686",
  "ui-addon-i18n": "static-1.10912",
  "ui-addon-react-router-dom": "static-1.9327",
  "unified-auth": "static-1.175",
  "unified-auth-core-lib": "static-1.456",
  "usage-tracker": "static-1.7112",
  "usage-tracker-core": "static-1.6962",
  "customer-data-property-utils": "static-1.7850",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15356",
  "marketplace-ui-common": "static-1.18882",
  "property-management-iframe": "static-1.12247",
  "quartz-config": "static-1.477",
  "quartz-core": "static-1.5918",
  "quartz-routing": "static-1.129",
  "quick-fetch": "static-1.3715",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4412",
  "ts-schema": "static-1.3885",
  "ui-universal-auth": "static-1.8661",
  "UIComponents": "static-3.8150",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3209",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2976",
  "quartz-webpack": "static-1.2923",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3754",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4613",
  "foundations-theming-specialty": "static-1.1905",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9207",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5154",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1134",
  "ui-fonts": "static-1.465",
  "ui-images": "static-2.1086",
  "bend-plugin-foundations-theming": "static-1.2672",
  "foundations-theming-base": "static-1.3174",
  "stylex": "static-1.27",
  "HeadJS": "static-2.705",
  "hs-test-utils-bend-plugin": "static-1.2896",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4108",
  "ai-components-ui-library": "static-1.8296",
  "ai-rendering-library": "static-1.9239",
  "chirp-fetch": "static-1.1663",
  "connections-embed-lib": "static-1.596",
  "copilot-toolkit": "static-1.10470",
  "laboratory-lib": "static-3.6941",
  "marketplace-embed": "static-1.21432",
  "marketplace-ui-details": "static-1.8778",
  "marketplace-ui-reviews": "static-1.18838",
  "marketplace-ui-tracking": "static-1.13053",
  "sanitize-text": "static-1.7919",
  "ui-addon-video-player": "static-1.8475",
  "usage-tracker-multi": "static-1.5526",
  "usage-tracker-session-replay": "static-1.4798",
  "wootric-nps": "static-1.6761",
  "apollo-link-hub-http": "static-2.4427",
  "immer": "static-1.33",
  "immerable": "static-1.3934",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2382",
  "reporting-data": "static-1.66439",
  "cssUtils": "static-1.725",
  "flux-actions": "static-1.305",
  "HubStyle": "static-2.11511",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9990",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10153",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7102",
  "icons": "static-2.619",
  "marketplace-ui-apps-core": "static-1.17415",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4302",
  "foundations-components-test-utils": "static-1.4968",
  "quartz-i18n": "static-1.374",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3511",
  "customer-data-objects": "static-1.7425",
  "property-translator": "static-1.5193",
  "frontend-preferences-client": "static-1.7703",
  "hs-promise-utils": "static-1.5371",
  "hubspot-apollo-client": "static-1.4659",
  "integrations-error-boundary-lib": "static-1.12771",
  "integrations-tracking-lib": "static-1.5364",
  "native-integrations-shared-strings": "static-1.7568",
  "reselect": "static-2.16",
  "sanitize": "static-1.4254",
  "superstore": "static-1.4550",
  "ui-shepherd-react": "static-3.9924",
  "ai-settings-ui-library": "static-1.7388",
  "hub-http-janus": "static-1.788",
  "hubspotter-http": "static-1.4458",
  "immutable-less": "static-1.4433",
  "marketplace-ui-client-types": "static-1.16289",
  "nav-meta": "static-1.28843",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10017",
  "ui-addon-upgrades": "static-9.17620",
  "inbound-db-properties-service-client": "static-1.3657",
  "property-management-common": "static-1.4534",
  "ui-addon-iframeable": "static-1.8821",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.478",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.374",
  "quartz-head": "static-1.364",
  "quartz-test": "static-1.374",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2926",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20230",
  "ContentUtils": "static-1.67566",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2264",
  "customer-data-filters-ui": "static-1.38833",
  "customer-data-objects-ui-components": "static-1.12784",
  "customer-data-reference-ui-components": "static-1.12921",
  "embedded-academy-lib": "static-1.13434",
  "ExportDialog": "static-6.10167",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40609",
  "reporting-snowflake": "static-1.55057",
  "reporting-ui-components": "static-2.63710",
  "reporting-visualizations": "static-1.58515",
  "ui-addon-teams": "static-1.21211",
  "magpie-lib": "static-1.5373",
  "magpie-types": "static-1.4833",
  "simple-logging-lib": "static-1.2830",
  "navigation-components": "static-1.17206",
  "ai-studio-lib": "static-1.10946",
  "developer-experience-shared-components": "static-1.10247",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7764",
  "ui-tool-access": "static-1.9923",
  "usage-based-billing-components-lib": "static-1.7948",
  "usage-tracker-anonymous": "static-1.5529",
  "usage-tracker-public": "static-1.6923",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3399",
  "persist-promise": "static-1.3486",
  "reference-resolvers": "static-1.7940",
  "ui-extensibility-client-types": "static-1.3727",
  "hubspot-apollo-cache": "static-1.118",
  "universal-page-editor-lib": "static-1.2777",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2135",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4850",
  "purchase-motions-components": "static-1.5454",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1329",
  "crm-component-utils": "static-1.38444",
  "crm-properties-common-lib": "static-1.5650",
  "framework-data-schema-resolvers": "static-1.6650",
  "reference-resolvers-lite": "static-1.7870",
  "navigation-messaging": "static-1.6533",
  "hubspotter-http-shared-msw-handlers": "static-1.9429",
  "cms-field-types": "static-1.4585",
  "content-icons-ui": "static-1.2147",
  "conversations-skeleton-state": "static-1.7028",
  "crm-message-bus": "static-1.42302",
  "customer-data-filters-ui-msw-helpers": "static-1.21267",
  "customer-data-ui-utilities": "static-1.9603",
  "FormUrlGenerator": "static-2.4510",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6555",
  "multi-account-reference-resolvers": "static-1.750",
  "onboarding-tours": "static-1.16228",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12981",
  "academy-common-lib": "static-1.12894",
  "content-assistance-lib": "static-1.7418",
  "dashboard-lib": "static-1.80554",
  "file-manager-components": "static-1.22829",
  "getting-started-shared-tasks": "static-1.17829",
  "hubspot-prosemirror": "static-1.17556",
  "hubspot-prosemirror-plugins": "static-1.17548",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19435",
  "share-with-third-party-component-lib": "static-1.8471",
  "ui-addon-draggable": "static-3.4546",
  "ui-asset-management-lib": "static-1.10680",
  "ui-business-units-lib": "static-1.8805",
  "user-context": "static-1.4874",
  "growth-payments-core": "static-1.24676",
  "reporting-plugins": "static-1.9954",
  "reporting-reports": "static-1.66117",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.505",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28815",
  "react-codemirror": "static-1.10406",
  "apps-service-types": "static-1.3659",
  "oauth-service-types": "static-1.4021",
  "onboarding-scopes": "static-1.6243",
  "onboarding-tours-client": "static-1.4442",
  "platform-infra-nav-components": "static-1.7475",
  "subscription-experience-data-types": "static-1.14560",
  "crm-record-cards-service-types": "static-1.3434",
  "location-customization-utils-lib": "static-1.8505",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2136",
  "purchase-motions-api": "static-1.5457",
  "signup-constants": "static-1.18343",
  "signup-ui-url-generator": "static-2.7845",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43467",
  "crm-actions": "static-1.6076",
  "crm-cards-data": "static-1.1166",
  "crm-cards-sdk": "static-1.42858",
  "customer-data-properties": "static-1.50746",
  "customer-data-properties-shared-msw-handlers": "static-1.8758",
  "customer-data-tracking": "static-1.6661",
  "conditional-properties-service-client": "static-1.3605",
  "crm-pipelines-api-client-types": "static-1.3946",
  "multi-currency-client-types": "static-1.3499",
  "external-options-client-types": "static-1.3966",
  "react-dnd-compat": "static-1.4401",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5130",
  "growth-onboarding-confetti": "static-1.2850",
  "growth-onboarding-next-action-utils": "static-1.1275",
  "onboarding-tours-utils": "static-1.294",
  "ui-shepherd-tracker": "static-1.7305",
  "academy-service-client": "static-1.3461",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27891",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8165",
  "video-components-external": "static-1.10505",
  "video-data-lib": "static-1.34163",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8349",
  "payment-link-components": "static-1.22890",
  "ui-addon-emoji-picker": "static-1.9668",
  "EmailSignatureEditor": "static-1.23863",
  "viral-links-lib": "static-1.6810",
  "data-token-picker": "static-1.16007",
  "FileManagerLib": "static-1.38469",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5024",
  "getting-started-shared-tasks-store": "static-1.16947",
  "campaign-roi-lib": "static-1.8216",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.170",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91157",
  "crm-links": "static-1.6036",
  "customer-data-sidebar": "static-2.45362",
  "enrichment-properties-lib": "static-1.14941",
  "crm-fe-perf": "static-1.22685",
  "calling-global-api": "static-1.63590",
  "calling-internal-common": "static-1.31071",
  "calling-lifecycle-internal": "static-1.64972",
  "calling-lifecycle-messages": "static-1.57266",
  "commerce-products-lib": "static-1.8804",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.454",
  "inbounddb-objects-service-types": "static-1.4031",
  "meetings-icalendar-utils-lib": "static-1.413",
  "object-builder-ui-client": "static-1.47905",
  "pipeline-validation-client-types": "static-1.3768",
  "property-value-citations": "static-1.1360",
  "pulse": "static-1.285",
  "smart-property-lib": "static-1.5823",
  "tiered-pricing": "static-1.796",
  "ui-addon-form-validation": "static-1.10774",
  "growth-onboarding-feedback-components": "static-1.6364",
  "content-media-composition-data-lib": "static-1.11378",
  "content-media-compositions": "static-2.15385",
  "media-bridge-lib": "static-1.18529",
  "commerce-tours-lib": "static-1.5685",
  "growth-onboarding-reliability": "static-1.4867",
  "sales-checkout-service-client": "static-1.3458",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21273",
  "sales-email-signature-service-client": "static-1.3625",
  "audio-components": "static-1.5582",
  "FileManagerCore": "static-1.38328",
  "FileManagerImages": "static-1.35980",
  "video-components": "static-1.12508",
  "crm_universal": "static-1.21625",
  "customer-data-email": "static-1.17634",
  "calling-error-reporting": "static-1.31077",
  "card-payment-highlight-lib": "static-1.36453",
  "card-subscription-highlight-lib": "static-1.38809",
  "commerce-billing-lib": "static-1.18448",
  "commerce-contract-lib": "static-1.11093",
  "customer-data-content": "static-1.26836",
  "invoices-highlight-card-lib": "static-1.53951",
  "orders-highlight-card-lib": "static-1.20822",
  "products-highlight-card-lib": "static-1.17088",
  "project-storage": "static-1.4512",
  "quotes-highlight-card-lib": "static-1.71099",
  "breeze-intelligence-kit": "static-1.5290",
  "crm-source-interpretation-lib": "static-1.5107",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9514",
  "policy-lib": "static-1.6561",
  "shared-worker-versioning": "static-1.10816",
  "calling-usage-tracker": "static-1.6318",
  "voice-sms-access-library": "static-1.190",
  "products-iframe-lib": "static-1.7261",
  "products-ui-components-shared-msw-handlers": "static-1.9813",
  "directed-graph": "static-1.717",
  "event-emitter": "static-1.728",
  "react-tinymce": "static-1.54566",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9577",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53692",
  "tinymce-plugins": "static-1.56806",
  "tinymce-themes": "static-1.55662",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4313",
  "video-embed": "static-1.34997",
  "social-insights-client-types": "static-1.21268",
  "sequences-lib": "static-1.7656",
  "ui-gdpr-components": "static-1.10127",
  "commerce-shared-components-lib": "static-1.17860",
  "commerce-subscription-lib": "static-1.36386",
  "commerce-tools-ui-lib": "static-1.9743",
  "utility-belt": "static-1.2323",
  "payments-enrollment-embed-lib": "static-1.21938",
  "products-ui-components": "static-1.39323",
  "quotes-client-types": "static-1.37187",
  "quotes-ui-lib": "static-1.79818",
  "SalesContentIndexUI": "static-3.8869",
  "accounting-integrations-ui-components": "static-1.6689",
  "invoices-ui-lib": "static-1.53967",
  "commerce-products-api": "static-1.1926",
  "SafeStorage": "static-1.4184",
  "invoices-iframe-lib": "static-1.56025",
  "quotes-modal-lib": "static-1.101775",
  "calling-orchestration-schema": "static-1.34967",
  "sales-views-client-types": "static-1.4072",
  "hub-http-contrib": "static-1.2824",
  "interframe": "static-3.4571",
  "tinymce-data": "static-1.39777",
  "ui-addon-sales-email": "static-1.4992",
  "layout-dnd-components": "static-1.11993",
  "layout-dnd-utils": "static-1.10968",
  "ui-brand-identity-lib": "static-1.13771",
  "NamespacedHubStyle": "static-2.8878",
  "outpost": "static-1.3984",
  "sequences-client-types-lib": "static-1.7513",
  "customer-data-associations": "static-1.7115",
  "framework-data-table": "static-2.11362",
  "customer-data-rte": "static-1.32398",
  "cv-backend-services": "static-1.1492",
  "growth-onboarding-empty-states": "static-1.5331",
  "InboxConnectUtils": "static-4.14172",
  "payments-post-enroll-local-storage-lib": "static-1.4892",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7097",
  "commerce-permissions": "static-1.532",
  "commerce-tax-lib": "static-1.292",
  "property-description-translator": "static-1.3639",
  "FireAlarmUi": "static-1.4309",
  "sales-templates-service-types-lib": "static-1.3976",
  "commerce-analytics-service-client": "static-1.3446",
  "totals-ui-components": "static-1.22948",
  "ContentData": "static-1.67641",
  "layout-data-lib": "static-1.9293",
  "deal-intel-decorators": "static-1.1193",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27666",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3619",
  "advanced-menus-core": "static-1.14783",
  "advanced-menus-lib": "static-1.11763",
  "ui-memberships-settings-lib": "static-1.33375",
  "deal-intel-utils": "static-1.1198",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14782",
  "simple-menus-lib": "static-1.16299"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11500",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.214",
  "data-fetching-client": "/data-fetching-client/static-1.9458",
  "foundations-components": "/foundations-components/static-1.7485",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.510",
  "foundations-theming": "/foundations-theming/static-1.4189",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7785",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9431",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11203",
  "I18n": "/I18n/static-7.1563",
  "jasmine-runner": "/jasmine-runner/static-1.6251",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11560",
  "quartz": "/quartz/static-1.6699",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16422",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2642",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8372",
  "settings-ui-lib": "/settings-ui-lib/static-1.12300",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6686",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10912",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9327",
  "unified-auth": "/unified-auth/static-1.175",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.456",
  "usage-tracker": "/usage-tracker/static-1.7112",
  "usage-tracker-core": "/usage-tracker-core/static-1.6962",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7850",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15356",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18882",
  "property-management-iframe": "/property-management-iframe/static-1.12247",
  "quartz-config": "/quartz-config/static-1.477",
  "quartz-core": "/quartz-core/static-1.5918",
  "quartz-routing": "/quartz-routing/static-1.129",
  "quick-fetch": "/quick-fetch/static-1.3715",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4412",
  "ts-schema": "/ts-schema/static-1.3885",
  "ui-universal-auth": "/ui-universal-auth/static-1.8661",
  "UIComponents": "/UIComponents/static-3.8150",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3209",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2976",
  "quartz-webpack": "/quartz-webpack/static-1.2923",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3754",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4613",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1905",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9207",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5154",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1134",
  "ui-fonts": "/ui-fonts/static-1.465",
  "ui-images": "/ui-images/static-2.1086",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2672",
  "foundations-theming-base": "/foundations-theming-base/static-1.3174",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.705",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2896",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4108",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8296",
  "ai-rendering-library": "/ai-rendering-library/static-1.9239",
  "chirp-fetch": "/chirp-fetch/static-1.1663",
  "connections-embed-lib": "/connections-embed-lib/static-1.596",
  "copilot-toolkit": "/copilot-toolkit/static-1.10470",
  "laboratory-lib": "/laboratory-lib/static-3.6941",
  "marketplace-embed": "/marketplace-embed/static-1.21432",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8778",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18838",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13053",
  "sanitize-text": "/sanitize-text/static-1.7919",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8475",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5526",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4798",
  "wootric-nps": "/wootric-nps/static-1.6761",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4427",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3934",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2382",
  "reporting-data": "/reporting-data/static-1.66439",
  "cssUtils": "/cssUtils/static-1.725",
  "flux-actions": "/flux-actions/static-1.305",
  "HubStyle": "/HubStyle/static-2.11511",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9990",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10153",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7102",
  "icons": "/icons/static-2.619",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17415",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4302",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4968",
  "quartz-i18n": "/quartz-i18n/static-1.374",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3511",
  "customer-data-objects": "/customer-data-objects/static-1.7425",
  "property-translator": "/property-translator/static-1.5193",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7703",
  "hs-promise-utils": "/hs-promise-utils/static-1.5371",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4659",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12771",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5364",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7568",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4254",
  "superstore": "/superstore/static-1.4550",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9924",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7388",
  "hub-http-janus": "/hub-http-janus/static-1.788",
  "hubspotter-http": "/hubspotter-http/static-1.4458",
  "immutable-less": "/immutable-less/static-1.4433",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16289",
  "nav-meta": "/nav-meta/static-1.28843",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10017",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17620",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3657",
  "property-management-common": "/property-management-common/static-1.4534",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8821",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.478",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.374",
  "quartz-head": "/quartz-head/static-1.364",
  "quartz-test": "/quartz-test/static-1.374",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2926",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20230",
  "ContentUtils": "/ContentUtils/static-1.67566",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2264",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38833",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12784",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12921",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13434",
  "ExportDialog": "/ExportDialog/static-6.10167",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40609",
  "reporting-snowflake": "/reporting-snowflake/static-1.55057",
  "reporting-ui-components": "/reporting-ui-components/static-2.63710",
  "reporting-visualizations": "/reporting-visualizations/static-1.58515",
  "ui-addon-teams": "/ui-addon-teams/static-1.21211",
  "magpie-lib": "/magpie-lib/static-1.5373",
  "magpie-types": "/magpie-types/static-1.4833",
  "simple-logging-lib": "/simple-logging-lib/static-1.2830",
  "navigation-components": "/navigation-components/static-1.17206",
  "ai-studio-lib": "/ai-studio-lib/static-1.10946",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10247",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7764",
  "ui-tool-access": "/ui-tool-access/static-1.9923",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7948",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5529",
  "usage-tracker-public": "/usage-tracker-public/static-1.6923",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3399",
  "persist-promise": "/persist-promise/static-1.3486",
  "reference-resolvers": "/reference-resolvers/static-1.7940",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3727",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.118",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2777",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2135",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4850",
  "purchase-motions-components": "/purchase-motions-components/static-1.5454",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1329",
  "crm-component-utils": "/crm-component-utils/static-1.38444",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5650",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6650",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7870",
  "navigation-messaging": "/navigation-messaging/static-1.6533",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9429",
  "cms-field-types": "/cms-field-types/static-1.4585",
  "content-icons-ui": "/content-icons-ui/static-1.2147",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7028",
  "crm-message-bus": "/crm-message-bus/static-1.42302",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21267",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9603",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4510",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6555",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.750",
  "onboarding-tours": "/onboarding-tours/static-1.16228",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12981",
  "academy-common-lib": "/academy-common-lib/static-1.12894",
  "content-assistance-lib": "/content-assistance-lib/static-1.7418",
  "dashboard-lib": "/dashboard-lib/static-1.80554",
  "file-manager-components": "/file-manager-components/static-1.22829",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17829",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17556",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17548",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19435",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8471",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4546",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10680",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8805",
  "user-context": "/user-context/static-1.4874",
  "growth-payments-core": "/growth-payments-core/static-1.24676",
  "reporting-plugins": "/reporting-plugins/static-1.9954",
  "reporting-reports": "/reporting-reports/static-1.66117",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.505",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28815",
  "react-codemirror": "/react-codemirror/static-1.10406",
  "apps-service-types": "/apps-service-types/static-1.3659",
  "oauth-service-types": "/oauth-service-types/static-1.4021",
  "onboarding-scopes": "/onboarding-scopes/static-1.6243",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4442",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7475",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14560",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3434",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8505",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2136",
  "purchase-motions-api": "/purchase-motions-api/static-1.5457",
  "signup-constants": "/signup-constants/static-1.18343",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7845",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43467",
  "crm-actions": "/crm-actions/static-1.6076",
  "crm-cards-data": "/crm-cards-data/static-1.1166",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42858",
  "customer-data-properties": "/customer-data-properties/static-1.50746",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8758",
  "customer-data-tracking": "/customer-data-tracking/static-1.6661",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3605",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3946",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3499",
  "external-options-client-types": "/external-options-client-types/static-1.3966",
  "react-dnd-compat": "/react-dnd-compat/static-1.4401",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5130",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2850",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1275",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.294",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7305",
  "academy-service-client": "/academy-service-client/static-1.3461",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27891",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8165",
  "video-components-external": "/video-components-external/static-1.10505",
  "video-data-lib": "/video-data-lib/static-1.34163",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8349",
  "payment-link-components": "/payment-link-components/static-1.22890",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9668",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23863",
  "viral-links-lib": "/viral-links-lib/static-1.6810",
  "data-token-picker": "/data-token-picker/static-1.16007",
  "FileManagerLib": "/FileManagerLib/static-1.38469",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5024",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16947",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8216",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.170",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91157",
  "crm-links": "/crm-links/static-1.6036",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45362",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14941",
  "crm-fe-perf": "/crm-fe-perf/static-1.22685",
  "calling-global-api": "/calling-global-api/static-1.63590",
  "calling-internal-common": "/calling-internal-common/static-1.31071",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64972",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57266",
  "commerce-products-lib": "/commerce-products-lib/static-1.8804",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.454",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4031",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.413",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47905",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3768",
  "property-value-citations": "/property-value-citations/static-1.1360",
  "pulse": "/pulse/static-1.285",
  "smart-property-lib": "/smart-property-lib/static-1.5823",
  "tiered-pricing": "/tiered-pricing/static-1.796",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10774",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6364",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11378",
  "content-media-compositions": "/content-media-compositions/static-2.15385",
  "media-bridge-lib": "/media-bridge-lib/static-1.18529",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5685",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4867",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3458",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21273",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3625",
  "audio-components": "/audio-components/static-1.5582",
  "FileManagerCore": "/FileManagerCore/static-1.38328",
  "FileManagerImages": "/FileManagerImages/static-1.35980",
  "video-components": "/video-components/static-1.12508",
  "crm_universal": "/crm_universal/static-1.21625",
  "customer-data-email": "/customer-data-email/static-1.17634",
  "calling-error-reporting": "/calling-error-reporting/static-1.31077",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36453",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38809",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18448",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11093",
  "customer-data-content": "/customer-data-content/static-1.26836",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53951",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20822",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17088",
  "project-storage": "/project-storage/static-1.4512",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71099",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5290",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5107",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9514",
  "policy-lib": "/policy-lib/static-1.6561",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10816",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6318",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.190",
  "products-iframe-lib": "/products-iframe-lib/static-1.7261",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9813",
  "directed-graph": "/directed-graph/static-1.717",
  "event-emitter": "/event-emitter/static-1.728",
  "react-tinymce": "/react-tinymce/static-1.54566",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9577",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53692",
  "tinymce-plugins": "/tinymce-plugins/static-1.56806",
  "tinymce-themes": "/tinymce-themes/static-1.55662",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4313",
  "video-embed": "/video-embed/static-1.34997",
  "social-insights-client-types": "/social-insights-client-types/static-1.21268",
  "sequences-lib": "/sequences-lib/static-1.7656",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10127",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17860",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36386",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9743",
  "utility-belt": "/utility-belt/static-1.2323",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21938",
  "products-ui-components": "/products-ui-components/static-1.39323",
  "quotes-client-types": "/quotes-client-types/static-1.37187",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79818",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8869",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6689",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53967",
  "commerce-products-api": "/commerce-products-api/static-1.1926",
  "SafeStorage": "/SafeStorage/static-1.4184",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56025",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101775",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34967",
  "sales-views-client-types": "/sales-views-client-types/static-1.4072",
  "hub-http-contrib": "/hub-http-contrib/static-1.2824",
  "interframe": "/interframe/static-3.4571",
  "tinymce-data": "/tinymce-data/static-1.39777",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4992",
  "layout-dnd-components": "/layout-dnd-components/static-1.11993",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10968",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13771",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8878",
  "outpost": "/outpost/static-1.3984",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7513",
  "customer-data-associations": "/customer-data-associations/static-1.7115",
  "framework-data-table": "/framework-data-table/static-2.11362",
  "customer-data-rte": "/customer-data-rte/static-1.32398",
  "cv-backend-services": "/cv-backend-services/static-1.1492",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5331",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14172",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4892",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7097",
  "commerce-permissions": "/commerce-permissions/static-1.532",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.292",
  "property-description-translator": "/property-description-translator/static-1.3639",
  "FireAlarmUi": "/FireAlarmUi/static-1.4309",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3976",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3446",
  "totals-ui-components": "/totals-ui-components/static-1.22948",
  "ContentData": "/ContentData/static-1.67641",
  "layout-data-lib": "/layout-data-lib/static-1.9293",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1193",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27666",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3619",
  "advanced-menus-core": "/advanced-menus-core/static-1.14783",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11763",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33375",
  "deal-intel-utils": "/deal-intel-utils/static-1.1198",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14782",
  "simple-menus-lib": "/simple-menus-lib/static-1.16299"
}
};
